import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { InvoicingService } from "./invoicing.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { Ebilling } from "./invoicing";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { LoaderService } from "../LoaderService";
declare var $: any;

@Component({
  templateUrl: "./invoicingdetail.ebilling.component.html"
})
export class InvoicingDetailEbillingComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Invoicing';
  public invoiceName: string = 'ebilling';
  public activeAccountId: string = '';
  public accessAccounts: IAccount[];
  public processAccount: IAccount;
  public ebillings: Ebilling[];
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public invoicingService: InvoicingService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    this.processAccount = null;
    this.processAccount = this.accessAccounts[0];
    this.ebillingOnInit();
  }  

  ebillingOnInit(): void {
    this.loaderService.display(true);
    this.invoicingService.getEbillingByAccountId(this.processAccount.id)
      .subscribe(
      (ebilling: Ebilling) => {
        ebilling.accountNumber = this.processAccount.name;
        ebilling.ledger = this.processAccount.ledger;
        this.ebillings = [];
        this.ebillings.push(ebilling);
        this.activeAccountId = this.processAccount.id;
        this.loaderService.display(false);
      },
      (error: any) => {
        this.loaderService.display(false);
        this.invoicingService.showError("Ebillings retrieval problem", <any>error);
      }
    );
  }

  onEbillingSubmit(ebilling: Ebilling): void {
    this.loaderService.display(true);
    this.invoicingService.saveEbilling(ebilling, this.processAccount.id)
      .subscribe(
      (ebilling: Ebilling) => {
        this.loaderService.display(false);
        this.invoicingService.showSuccess("Ebilling", "info updated successfully.");
      },
      (error: any) => {
        this.loaderService.display(false);
        this.invoicingService.showError("Ebilling update problem", <any>error);
      }
      );
  }

  ngAfterViewInit(): void {

  }

  onAccountTabClick(index: number) {
    this.processAccount = this.accessAccounts[index];
    this.ebillingOnInit();
  }
}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicingdetail.ebilling.component.ts